module.exports = __webpack_public_path__ + "static/media/i.36538e8c.jpg";